import React, { useState } from 'react';

// Components
import AdminProvider from './provider/AdminProvider';
import Binder from './components/AdminBinder/Binder';
import { Flexbox, StyledToastContainer } from '@ibinder/ui-common-core';

import styled from 'styled-components';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';

export const TestPlaceHolder = styled(Flexbox)`
  justify-content: right;
  padding: 2rem;
`;

const App = () => {
  return (
    <AdminProvider>
      <Navbar />
      <StyledToastContainer autoClose={false} newestOnTop={true} />
      <Binder />
      <Footer />
    </AdminProvider>
  );
};

export default App;
